'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var bs58 = require('bs58');

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

function getB58Str(peer) {
  var b58Str;

  if (typeof peer === 'string') {
    b58Str = peer;
  } else if (Buffer.isBuffer(peer)) {
    b58Str = bs58.encode(peer).toString();
  } else if (PeerId.isPeerId(peer)) {
    b58Str = peer.toB58String();
  } else if (PeerInfo.isPeerInfo(peer)) {
    b58Str = peer.id.toB58String();
  } else {
    throw new Error('not valid PeerId or PeerInfo, or B58Str');
  }

  return b58Str;
}

var PeerBook =
/*#__PURE__*/
function () {
  function PeerBook() {
    _classCallCheck(this, PeerBook);

    this._peers = {};
  } // checks if peer exists
  // peer can be PeerId, b58String or PeerInfo


  _createClass(PeerBook, [{
    key: "has",
    value: function has(peer) {
      var b58Str = getB58Str(peer);
      return Boolean(this._peers[b58Str]);
    }
    /**
     * Stores a peerInfo, if already exist, merges the new into the old.
     *
     * @param {PeerInfo} peerInfo
     * @param {Boolean} replace
     * @returns {PeerInfo}
     */

  }, {
    key: "put",
    value: function put(peerInfo, replace) {
      var localPeerInfo = this._peers[peerInfo.id.toB58String()]; // insert if doesn't exist or replace if replace flag is true


      if (!localPeerInfo || replace) {
        this._peers[peerInfo.id.toB58String()] = peerInfo;
        return peerInfo;
      } // peerInfo.replace merges by default if none to replace are passed


      peerInfo.multiaddrs.forEach(function (ma) {
        return localPeerInfo.multiaddrs.add(ma);
      }); // pass active connection state

      var ma = peerInfo.isConnected();

      if (ma) {
        localPeerInfo.connect(ma);
      } // pass known protocols


      peerInfo.protocols.forEach(function (p) {
        return localPeerInfo.protocols.add(p);
      });

      if (!localPeerInfo.id.privKey && peerInfo.id.privKey) {
        localPeerInfo.id.privKey = peerInfo.id.privKey;
      }

      if (!localPeerInfo.id.pubKey && peerInfo.id.pubKey) {
        localPeerInfo.id.pubKey = peerInfo.id.pubKey;
      }

      return localPeerInfo;
    }
    /**
     * Get the info to the given PeerId, PeerInfo or b58Str id
     *
     * @param {PeerId} peer
     * @returns {PeerInfo}
     */

  }, {
    key: "get",
    value: function get(peer) {
      var b58Str = getB58Str(peer);
      var peerInfo = this._peers[b58Str];

      if (peerInfo) {
        return peerInfo;
      }

      throw new Error('PeerInfo not found');
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this._peers;
    }
  }, {
    key: "getAllArray",
    value: function getAllArray() {
      var _this = this;

      return Object.keys(this._peers).map(function (b58Str) {
        return _this._peers[b58Str];
      });
    }
  }, {
    key: "getMultiaddrs",
    value: function getMultiaddrs(peer) {
      var info = this.get(peer);
      return info.multiaddrs.toArray();
    }
  }, {
    key: "remove",
    value: function remove(peer) {
      var b58Str = getB58Str(peer);

      if (this._peers[b58Str]) {
        delete this._peers[b58Str];
      }
    }
  }]);

  return PeerBook;
}();

module.exports = PeerBook;